import React, { useEffect, useState, lazy, memo, createElement, Component } from 'react';
import { CheckCircle2, XCircle, Star, Zap, Check, Store, TrendingUp, Smartphone, Wallet, LayoutDashboard, Megaphone, Truck, FileSpreadsheet, Ticket } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const CountdownTimer = memo(() => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 27,
    seconds: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex gap-2 font-mono text-xl md:text-2xl font-bold text-white" data-id="element-1">
      <div className="bg-[#1A237E] px-2 py-1 rounded border border-white/20" data-id="element-2">
        {String(timeLeft.hours).padStart(2, '0')}h
      </div>
      <span className="text-white" data-id="element-3">:</span>
      <div className="bg-[#1A237E] px-2 py-1 rounded border border-white/20" data-id="element-4">
        {String(timeLeft.minutes).padStart(2, '0')}m
      </div>
      <span className="text-white" data-id="element-5">:</span>
      <div className="bg-[#1A237E] px-2 py-1 rounded border border-white/20" data-id="element-6">
        {String(timeLeft.seconds).padStart(2, '0')}s
      </div>
    </div>;
});
const FloatingNotification = memo(() => {
  const [visible, setVisible] = useState(false);
  const [animClass, setAnimClass] = useState('notif-enter');
  const [currentIndex, setCurrentIndex] = useState(0);
  const notifications = [{
    n: 'Jorge',
    l: 'Quilmes',
    p: 'el Pack Imparable',
    t: 'hace 5 min'
  }, {
    n: 'Marta',
    l: 'Mendoza',
    p: 'el Bono 1 - Excel Caja',
    t: 'hace 2 min'
  }, {
    n: 'Almacén Los Amigos',
    l: 'Salta',
    p: 'el sistema completo',
    t: 'recién'
  }, {
    n: 'Carlos',
    l: 'Rosario',
    p: 'la Biblia del Almacenero',
    t: 'hace 8 min'
  }, {
    n: 'Lucía',
    l: 'Posadas',
    p: 'el Kit de Carteles Pro',
    t: 'hace 12 min'
  }, {
    n: 'Diego',
    l: 'Bahía Blanca',
    p: 'el Pack Imparable',
    t: 'hace 15 min'
  }, {
    n: 'Elena',
    l: 'Neuquén',
    p: 'la Guía Cero Deuda',
    t: 'hace 4 min'
  }, {
    n: 'Roberto',
    l: 'Tucumán',
    p: 'el sistema completo',
    t: 'hace 20 min'
  }, {
    n: 'Kiosco El Sol',
    l: 'Córdoba',
    p: 'el Pack Imparable',
    t: 'hace 3 min'
  }, {
    n: 'Sonia',
    l: 'La Plata',
    p: 'el Bono 1 - Excel Caja',
    t: 'hace 10 min'
  }, {
    n: 'Pedro',
    l: 'Santa Fe',
    p: 'la Biblia del Almacenero',
    t: 'hace 6 min'
  }, {
    n: 'Almacén Don Luis',
    l: 'Corrientes',
    p: 'el sistema completo',
    t: 'hace 1 min'
  }, {
    n: 'Mariana',
    l: 'Mar del Plata',
    p: 'el Kit de Carteles Pro',
    t: 'hace 18 min'
  }, {
    n: 'Gustavo',
    l: 'Resistencia',
    p: 'el Pack Imparable',
    t: 'hace 25 min'
  }, {
    n: 'Fabiana',
    l: 'San Juan',
    p: 'la Guía Cero Deuda',
    t: 'hace 7 min'
  }, {
    n: 'Kiosco Central',
    l: 'San Luis',
    p: 'el sistema completo',
    t: 'recién'
  }, {
    n: 'Andrés',
    l: 'Paraná',
    p: 'el Pack Imparable',
    t: 'hace 9 min'
  }, {
    n: 'Beatriz',
    l: 'Formosa',
    p: 'el Bono 1 - Excel Caja',
    t: 'hace 14 min'
  }, {
    n: 'Hugo',
    l: 'Catamarca',
    p: 'la Biblia del Almacenero',
    t: 'hace 11 min'
  }, {
    n: 'Almacén La Nueva',
    l: 'Jujuy',
    p: 'el sistema completo',
    t: 'hace 5 min'
  }];
  useEffect(() => {
    const showNext = () => {
      setAnimClass('notif-enter');
      setVisible(true);
      setTimeout(() => {
        setAnimClass('notif-exit');
        setTimeout(() => {
          setVisible(false);
          setCurrentIndex(prev => (prev + 1) % notifications.length);
        }, 300);
      }, 4000);
    };
    const initialDelay = setTimeout(showNext, 3000);
    const interval = setInterval(showNext, 13000); // Aparece cada 13 segundos
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [notifications.length]);
  const current = notifications[currentIndex];
  if (!visible) return null;
  return <div className={`fixed top-4 left-4 md:top-6 md:left-6 z-[100] bg-white shadow-xl rounded-lg p-3 border border-slate-100 flex items-center gap-3 max-w-[280px] md:max-w-sm ${animClass}`} data-id="element-7">
      <div className="flex-shrink-0 w-8 h-8 bg-green-50 rounded-full flex items-center justify-center text-[#10A37F]" data-id="element-8">
        <Check size={18} strokeWidth={3} data-id="element-9" />
      </div>
      <div className="flex-grow min-w-0" data-id="element-10">
        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-tight mb-0.5" data-id="element-11">
          Venta verificada
        </p>
        <p className="text-xs md:text-sm text-[#1A237E] leading-tight" data-id="element-12">
          <span className="font-bold" data-id="element-13">{current.n}</span> de {current.l}
          <br data-id="element-14" />
          compró <span className="font-bold" data-id="element-15">{current.p}</span>
        </p>
        <p className="text-[10px] text-slate-400 mt-1" data-id="element-16">{current.t}</p>
      </div>
      <button onClick={() => setVisible(false)} className="flex-shrink-0 text-slate-300 hover:text-slate-500" aria-label="Cerrar" data-id="element-17">
        <XCircle size={14} data-id="element-18" />
      </button>
    </div>;
});
const SectionTitle = memo(({
  children,
  subtitle,
  light = false
}: {
  children: React.ReactNode;
  subtitle?: string;
  light?: boolean;
}) => <div className="text-center mb-4 md:mb-10" data-id="element-19">
      <h2 className={`text-xl md:text-5xl font-bold mb-2 md:mb-4 ${light ? 'text-white' : 'text-[#121212]'}`} data-id="element-20">
        {children}
      </h2>
      {subtitle && <p className={`text-xs md:text-lg ${light ? 'text-slate-200' : 'text-slate-600'} max-w-2xl mx-auto font-sans px-4`} data-id="element-21">
          {subtitle}
        </p>}
    </div>);
const CTAButton = memo(({
  children,
  secondary = false,
  whatsapp = false,
  className = '',
  href = '',
  onClick
}: {
  children: React.ReactNode;
  secondary?: boolean;
  whatsapp?: boolean;
  className?: string;
  href?: string;
  onClick?: () => void;
}) => {
  const buttonEl = <button className={`
          cta-pulse w-full md:w-auto px-10 py-5 rounded-full font-bold text-[14px] transition-transform transform hover:scale-105 active:scale-95 shadow-xl
          ${whatsapp ? 'bg-[#25D366] text-white hover:bg-[#128C7E]' : secondary ? 'bg-white text-[#1A237E] border-2 border-slate-200 hover:bg-slate-50' : 'bg-[#10A37F] text-white hover:bg-[#0d8a6b]'}
          ${className}
        `} onClick={onClick} data-id="element-22">
        {children}
      </button>;
  if (href) {
    const isInternal = href.startsWith('#');
    return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className="w-full md:w-auto block" onClick={e => {
      if (isInternal) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }} data-id="element-23">
          {buttonEl}
        </a>;
  }
  return buttonEl;
});
const statsData = [{
  label: 'Comerciantes',
  value: '+2.500'
}, {
  label: 'Tomos Máster',
  value: '5'
}, {
  label: 'Páginas',
  value: '600+'
}, {
  label: 'Calificación',
  value: '4.9/5',
  stars: true
}];
const testimonialsData = [{
  n: 'Juan P.',
  l: 'Kiosquero, Córdoba',
  q: 'Con el Excel del Bono 1 supe exactamente cuánto estaba ganando y dejé de sacar plata de la caja para gastos de mi casa.',
  i: 'JP'
}, {
  n: 'Marta S.',
  l: 'Almacenera, PBA',
  q: 'La guía de precios me salvó. Los proveedores subían el lunes y yo ya sabía cómo remarcar sin perder clientes.',
  i: 'MS'
}, {
  n: 'Carlos R.',
  l: 'Autoservicio, Rosario',
  q: 'Por fin alguien que entiende lo que es lidiar con el fiado y el pedido del lunes.',
  i: 'CR'
}];
const problemItems = ['Sin saber calcular el Margen Real vs. la Inflación.', 'Con un fiado descontrolado que se come tu capital.', 'Perdiendo clientes frente a las grandes cadenas.', 'Con miedo a las deudas con los proveedores.'];
const modulesData = [{
  t: 'TOMO 1: EL CEREBRO CONTABLE',
  d: 'Control de caja diaria y separación de finanzas personales.',
  iconName: 'LayoutDashboard'
}, {
  t: 'TOMO 2: INGENIERÍA DE PRECIOS',
  d: 'Cómo remarcar con inflación y proteger el costo de reposición.',
  iconName: 'TrendingUp'
}, {
  t: 'TOMO 3: EL IMÁN DE CLIENTES',
  d: 'Marketing de barrio y cartelería que atrae vecinos a tu local.',
  iconName: 'Megaphone'
}, {
  t: 'TOMO 4: VENTA DIGITAL',
  d: 'WhatsApp Business e Instagram para vender a través del celular.',
  iconName: 'Smartphone'
}, {
  t: 'TOMO 5: PROVEEDORES Y STOCK',
  d: 'El arte de comprar bien, negociar crédito y eliminar vencimientos.',
  iconName: 'Truck'
}];
const bonusesData = [{
  t: 'Bono 1: EXCEL CAJA TOTAL',
  d: 'Sistema automático de control de ventas y gastos.',
  iconName: 'FileSpreadsheet'
}, {
  t: 'Bono 2: KIT DE CARTELES PRO',
  d: '30 diseños listos para imprimir (Medios de pago, Promos, Servicios).',
  iconName: 'Ticket'
}, {
  t: 'Bono 3: GUÍA CERO DEUDA',
  d: 'El plan de 90 días para sanear tus finanzas con proveedores.',
  iconName: 'Wallet'
}];
const pricingFeatures = ['5 Tomos de Gestión Profesional', 'Planilla Excel de Caja Automática', 'Kit de 30 Carteles Imprimibles', 'Guía de Negociación con Proveedores', 'Manual de Venta por WhatsApp e IG', 'Acceso inmediato para siempre'];
const comparisonData = [{
  s: 'Sube el proveedor',
  no: '¿Cuánto remarco? ¿Perderé?',
  yes: 'Planilla Tomo 2: Blindás tu margen.'
}, {
  s: 'El Fiado',
  no: 'Cuadernito tachado y desorden',
  yes: 'Planilla Bono 1: Control total y cobro.'
}, {
  s: 'Poca Gente',
  no: 'Esperás que entren de casualidad',
  yes: 'Tomo 3 y 4: Atraés gente por redes.'
}, {
  s: 'Deudas',
  no: 'Incertidumbre y estrés',
  yes: 'Bono 3: Plan de pago saneado.'
}];
const iconMap: Record<string, ComponentType<any>> = {
  LayoutDashboard,
  TrendingUp,
  Megaphone,
  Smartphone,
  Truck,
  FileSpreadsheet,
  Ticket,
  Wallet
};
export function LandingPage() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 768px)');
    const update = () => setIsDesktop(mq.matches);
    update();
    if (mq.addEventListener) {
      mq.addEventListener('change', update);
    } else {
      mq.addListener(update);
    }
    return () => {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', update);
      } else {
        mq.removeListener(update);
      }
    };
  }, []);
  useEffect(() => {
    // Load Google Fonts non-blocking after first paint
    const loadFonts = () => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Playfair+Display:wght@700;800&display=swap';
      document.head.appendChild(link);
    };
    const preconnectFonts = document.createElement('link');
    preconnectFonts.rel = 'preconnect';
    preconnectFonts.href = 'https://fonts.gstatic.com';
    preconnectFonts.crossOrigin = 'anonymous';
    document.head.appendChild(preconnectFonts);
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://cdn.magicpatterns.com';
    preconnect.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect);
    const loadPixel = () => {
      if (window.fbq) return;
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      window.fbq('init', '929826529816985');
      window.fbq('track', 'PageView');
    };
    const idle: any = (window as any).requestIdleCallback;
    let timeoutId: number | undefined;
    let idleId: number | undefined;
    let fontsTimeout: number | undefined;
    let notifTimeout: number | undefined;
    // Load fonts after initial paint
    fontsTimeout = window.setTimeout(loadFonts, 100);
    // Defer pixel
    if (typeof idle === 'function') {
      idleId = idle(loadPixel, {
        timeout: 4000
      });
    } else {
      timeoutId = window.setTimeout(loadPixel, 3000);
    }
    // Defer floating notification mount entirely until after load
    notifTimeout = window.setTimeout(() => setShowNotification(true), 5000);
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (fontsTimeout) clearTimeout(fontsTimeout);
      if (notifTimeout) clearTimeout(notifTimeout);
      if (idleId && (window as any).cancelIdleCallback) {
        ;
        (window as any).cancelIdleCallback(idleId);
      }
    };
  }, []);
  return <main className="min-h-screen font-sans bg-white" data-id="element-24">
      {showNotification && <FloatingNotification data-id="element-25" />}

      <header className="relative bg-[#1A237E] flex flex-col text-white overflow-hidden" data-id="element-26">
        <div className="absolute inset-0 opacity-10" data-id="element-27">
          <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent" data-id="element-28"></div>
        </div>

        <div className="container mx-auto px-4 flex-grow flex flex-col justify-center py-8 md:py-24 relative z-10" data-id="element-29">
          <div className="max-w-5xl mx-auto text-center flex flex-col items-center h-full justify-center" data-id="element-30">
            <div className="flex flex-col items-center" data-id="element-31">
              <div className="fade-in-up inline-flex items-center gap-2 bg-white/10 border border-white/20 px-4 py-1 rounded-full text-white text-[10px] md:text-base font-bold mb-3 md:mb-10 backdrop-blur-sm" data-id="element-32">
                🏪 COMERCIO IMPARABLE 2026™
              </div>
              <h1 className="md:text-8xl font-bold mb-2 md:mb-10 text-white text-[28px]" data-id="element-33">
                La Biblia del Almacenero y Kiosquero , listo para usar.
              </h1>
              <p className="text-[13px] md:text-3xl text-white/80 mb-4 md:mb-12 max-w-4xl mx-auto leading-relaxed px-4 italic" data-id="element-34">
                El método probado para controlar tu caja, blindarte contra la
                inflación y profesionalizar tu negocio de barrio.
              </p>
            </div>

            <div className="relative max-w-[288px] md:max-w-[1075px] mx-auto mb-5 md:mb-16" data-id="element-35">
              <div className="relative z-10 bg-white/5 p-2 md:p-6 rounded-2xl md:rounded-3xl shadow-2xl border border-white/10" data-id="element-36">
                <img src="https://cdn.magicpatterns.com/uploads/bCpckAiwCk9qquuDXjmnBV/comercio_imparable_web.jpg" alt="Comercio Imparable Mockup" className="w-full h-auto rounded-xl md:rounded-2xl shadow-lg" width={1200} height={800} fetchPriority="high" decoding="async" sizes="(max-width: 768px) 280px, 1075px" data-id="element-37" />
                <div className="absolute -bottom-2 -right-2 bg-[#FFC107] text-[#1A237E] px-3 py-1 md:p-6 rounded-xl shadow-xl font-bold text-[10px] md:text-xl" data-id="element-38">
                  METODO PRACTICO Y SENCILLO
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center w-full" data-id="element-39">
              <CTAButton href="#pricing" className="uppercase tracking-wide px-8 py-4 md:px-16 md:py-8 text-[14px] md:text-2xl mb-3 md:mb-10" data-id="element-40">
                → ¡QUIERO ORDENAR MI NEGOCIO YA!
              </CTAButton>
              <div className="flex justify-center gap-3 md:gap-10 text-white/60 font-medium text-[9px] md:text-lg mb-4 md:mb-8" data-id="element-41">
                <div className="flex items-center gap-2 bg-white/5 px-3 py-1 rounded-full border border-white/10" data-id="element-42">
                  +600 Páginas de gestión
                </div>
                <div className="flex items-center gap-2 bg-white/5 px-3 py-1 rounded-full border border-white/10" data-id="element-43">
                  <Zap size={12} className="md:w-5 md:h-5" data-id="element-44" /> Acceso Instantáneo
                </div>
              </div>
              <div className="mb-4 md:mb-10" data-id="element-45">
                <img src="https://cdn.magicpatterns.com/uploads/tarRQxgmUge2kobeVn2KNG/garantia-7-dias-250.webp" alt="Garantía 7 días de reembolso" className="w-16 md:w-32 h-auto" width={128} height={128} loading="lazy" decoding="async" data-id="element-46" />
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-4 md:p-8 shadow-2xl inline-block self-center hidden md:block" data-id="element-47">
              <p className="text-white/60 font-bold uppercase tracking-widest text-[12px] md:text-sm mb-3 md:mb-4" data-id="element-48">
                ⏰ EL PRECIO PROMOCIONAL CIERRA EN:
              </p>
              {isDesktop && <CountdownTimer data-id="element-49" />}
            </div>
          </div>
        </div>
      </header>

      <section className="py-5 md:py-12 bg-[#1A237E] text-white" data-id="element-50">
        <div className="container mx-auto px-4" data-id="element-51">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8 max-w-4xl mx-auto text-center" data-id="element-52">
            {statsData.map((stat, i) => <div key={i} data-id="element-53">
                <p className="text-2xl md:text-4xl font-bold mb-1" data-id="element-54">
                  {stat.value}
                </p>
                {stat.stars && <div className="flex justify-center text-[#FFC107] mb-1" data-id="element-55">
                    {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-56" />)}
                  </div>}
                <p className="text-[10px] md:text-xs uppercase tracking-widest font-bold opacity-80" data-id="element-57">
                  {stat.label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-6 md:py-24 bg-white" data-id="element-58">
        <div className="container mx-auto px-4" data-id="element-59">
          <div className="grid md:grid-cols-3 gap-4 md:gap-8 max-w-6xl mx-auto" data-id="element-60">
            {testimonialsData.map((test, i) => <div key={i} className="bg-[#F5F5F5] p-5 md:p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-61">
                <div className="flex gap-1 mb-3 md:mb-4 text-[#1A237E]" data-id="element-62">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-63" />)}
                </div>
                <p className="text-[#0D0D0D] italic mb-4 md:mb-6 leading-relaxed text-sm md:text-base" data-id="element-64">
                  "{test.q}"
                </p>
                <div className="flex items-center gap-4" data-id="element-65">
                  <div className="w-10 h-10 bg-[#1A237E] rounded-full flex items-center justify-center font-bold text-white" data-id="element-66">
                    {test.i}
                  </div>
                  <div data-id="element-67">
                    <p className="font-bold text-[#0D0D0D]" data-id="element-68">{test.n}</p>
                    <p className="text-xs text-slate-500" data-id="element-69">{test.l}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-6 md:py-24 bg-[#0D0D0D] text-white" data-id="element-70">
        <div className="container mx-auto px-4" data-id="element-71">
          <SectionTitle light subtitle="Abrís temprano. Atendés todo el día. Pero el dinero se te escapa. No es que no vendas, es que te falta un sistema de gestión real." data-id="element-72">
            ¿Cuántas veces cerrás el día sintiendo que vendiste un montón pero
            la caja no rinde?
          </SectionTitle>
          <div className="grid md:grid-cols-2 gap-2.5 md:gap-4 max-w-4xl mx-auto mt-5 md:mt-12" data-id="element-73">
            {problemItems.map((item, i) => <div key={i} className="bg-white/5 border border-white/10 p-3 md:p-6 rounded-xl flex gap-3 md:gap-4 items-start" data-id="element-74">
                <XCircle className="text-[#FFC107] shrink-0 mt-1" size={20} data-id="element-75" />
                <p className="text-white/90 font-medium text-sm md:text-lg" data-id="element-76">
                  {item}
                </p>
              </div>)}
          </div>
          <div className="mt-6 md:mt-16 max-w-3xl mx-auto bg-[#1A237E]/20 border-l-8 border-[#1A237E] p-4 md:p-8 rounded-r-2xl shadow-sm text-center" data-id="element-77">
            <p className="text-lg md:text-3xl font-bold text-white italic" data-id="element-78">
              ¿Y si esta fuera la última vez que enfrentás una suba de precios
              sin saber qué hacer?
            </p>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-24 bg-white" data-id="element-79">
        <div className="container mx-auto px-4 text-center" data-id="element-80">
          <div className="inline-block bg-[#1A237E] text-white px-4 py-1 md:px-5 md:py-1.5 rounded-full font-bold text-[10px] md:text-xs uppercase tracking-widest mb-3 md:mb-8" data-id="element-81">
            SOLUCIÓN INTEGRAL
          </div>
          <h2 className="text-2xl md:text-6xl font-bold mb-3 md:mb-6 text-[#0D0D0D]" data-id="element-82">
            🏪 COMERCIO IMPARABLE 2026™
          </h2>
          <p className="text-sm md:text-2xl text-slate-600 mb-5 md:mb-12 max-w-3xl mx-auto" data-id="element-83">
            Ebook Central + 3 Bonos Estratégicos. 100% adaptado a la realidad de
            Argentina y LATAM. No más improvisación.
          </p>
          <div className="max-w-4xl mx-auto mb-2 md:mb-16 relative" data-id="element-84">
            <img src="https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&q=80&w=1200" alt="Pack Completo" className="w-full h-auto rounded-2xl md:rounded-3xl shadow-2xl border border-slate-200" loading="lazy" decoding="async" width={800} height={533} sizes="(max-width: 768px) 90vw, 800px" data-id="element-85" />
          </div>
        </div>
      </section>

      <section className="py-6 md:py-24 bg-[#F5F5F5]" data-id="element-86">
        <div className="container mx-auto px-4" data-id="element-87">
          <SectionTitle subtitle="La estructura maestra para transformar tu negocio." data-id="element-88">
            📚 LOS 5 TOMOS DEL SISTEMA
          </SectionTitle>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8 max-w-6xl mx-auto" data-id="element-89">
            {modulesData.map((m, i) => {
            const IconComp = iconMap[m.iconName];
            return <div key={i} className="bg-white p-5 md:p-8 rounded-2xl shadow-xl border-t-4 border-[#1A237E] text-center md:text-left flex flex-col items-center md:items-start" data-id="element-90">
                  <div className="text-[#1A237E] mb-3 md:mb-4" data-id="element-91">
                    {IconComp && <IconComp size={24} data-id="element-92" />}
                  </div>
                  <h3 className="text-base md:text-xl font-bold mb-2 md:mb-3 text-[#0D0D0D]" data-id="element-93">
                    {m.t}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-sm md:text-base" data-id="element-94">
                    {m.d}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="py-6 md:py-24 bg-white" data-id="element-95">
        <div className="container mx-auto px-4" data-id="element-96">
          <SectionTitle subtitle="Valor total bonos: $55.000 → GRATIS con tu pack" data-id="element-97">
            🎁 3 BONOS ESTRATÉGICOS
          </SectionTitle>
          <div className="grid md:grid-cols-3 gap-3 md:gap-6 max-w-6xl mx-auto" data-id="element-98">
            {bonusesData.map((b, i) => {
            const IconComp = iconMap[b.iconName];
            return <div key={i} className="bg-[#F5F5F5] p-4 md:p-6 rounded-2xl border border-slate-100 relative overflow-hidden text-center md:text-left flex flex-col items-center md:items-start" data-id="element-99">
                  <div className="absolute top-0 right-0 bg-[#FFC107] text-[#1A237E] text-[10px] font-bold px-3 py-1 rounded-bl-lg uppercase" data-id="element-100">
                    Gratis
                  </div>
                  <div className="text-[#1A237E] mb-3 md:mb-4" data-id="element-101">
                    {IconComp && <IconComp size={24} data-id="element-102" />}
                  </div>
                  <h3 className="text-base md:text-lg font-bold mb-1.5 md:mb-2 text-[#0D0D0D]" data-id="element-103">
                    {b.t}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-104">
                    {b.d}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="py-[10px] md:py-16 bg-[#1A237E] text-white" id="pricing" data-id="element-105">
        <div className="container mx-auto px-4" data-id="element-106">
          <div className="text-center mb-2 md:mb-8" data-id="element-107">
            <h2 className="md:text-5xl font-bold mb-1 text-white text-[18px]" data-id="element-108">
              LLEVATE TU PACK COMPLETO ⭐
            </h2>
            <p className="text-[10px] md:text-lg text-slate-200 max-w-2xl mx-auto font-sans px-4" data-id="element-109">
              Acceso inmediato a todo el material en formato digital.
            </p>
          </div>
          <div className="max-w-2xl mx-auto" data-id="element-110">
            <div className="bg-white/5 rounded-xl md:rounded-3xl p-3 md:p-10 text-white shadow-2xl flex flex-col border-2 md:border-4 border-[#FFC107] relative backdrop-blur-sm" data-id="element-111">
              <div className="text-center mb-2 md:mb-6" data-id="element-112">
                <h3 className="text-base md:text-2xl font-bold mb-0.5" data-id="element-113">
                  PACK COMERCIO IMPARABLE
                </h3>
                <p className="text-white/60 text-[9px] md:text-xs" data-id="element-114">
                  5 Tomos + 3 Bonos
                </p>
              </div>
              <div className="text-center mb-2 md:mb-6" data-id="element-115">
                <p className="text-white/40 line-through text-[10px] md:text-lg mb-0.5" data-id="element-116">
                  $60.000 ARS
                </p>
                <p className="text-3xl md:text-6xl font-bold text-[#FFC107]" data-id="element-117">
                  $19.990
                </p>
                <p className="text-[10px] md:text-lg font-medium inline-block ml-1" data-id="element-118">
                  ARS
                </p>
              </div>

              <ul className="grid grid-cols-2 md:grid-cols-2 gap-x-2 gap-y-1 mb-3 md:mb-8 border-y border-white/10 py-2 md:py-0 md:border-none" data-id="element-119">
                {pricingFeatures.map((item, i) => <li key={i} className="flex items-center gap-1 text-[9px] md:text-sm font-medium" data-id="element-120">
                    <CheckCircle2 size={10} className="text-[#10A37F] shrink-0 md:w-4 md:h-4" data-id="element-121" />
                    <span className="truncate" data-id="element-122">{item}</span>
                  </li>)}
              </ul>

              <div className="flex flex-col gap-2" data-id="element-123">
                <CTAButton href="https://checkout.guiadigital360.online/cart/45001524576325:1" className="w-full py-2.5 md:py-5 text-sm md:text-xl" data-id="element-124">
                  → ¡QUIERO EL SISTEMA YA!
                </CTAButton>
                <p className="text-center text-[10px] md:text-xs font-bold text-[#FFC107] uppercase tracking-tight py-1" data-id="element-125">
                  "SI TUVISTE PROBLEMAS CON EL PAGO , TE YUDAMOS "
                </p>
                <CTAButton whatsapp href="https://wa.me/5492966244076?text=Hola" className="w-full py-2 md:py-4 text-[10px] md:text-sm" data-id="element-126">
                  AYUDA POR WHATSAPP
                </CTAButton>
              </div>

              <p className="mt-2 md:mt-5 text-center text-[#FFC107] font-bold text-[8px] md:text-sm" data-id="element-127">
                ⚠️ El precio sube $10.000 pronto.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-24 bg-white" data-id="element-128">
        <div className="container mx-auto px-4" data-id="element-129">
          <SectionTitle subtitle="La diferencia entre un negocio que sobrevive y uno que prospera, tiene el valor de 3 coca colas" data-id="element-130">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </SectionTitle>
          <div className="hidden md:block max-w-4xl mx-auto overflow-hidden rounded-2xl border border-slate-200 shadow-xl" data-id="element-131">
            <table className="w-full text-left border-collapse" data-id="element-132">
              <thead data-id="element-133">
                <tr className="bg-[#1A237E] text-white" data-id="element-134">
                  <th className="p-6 font-bold" data-id="element-135">SITUACIÓN</th>
                  <th className="p-6 font-bold" data-id="element-136">❌ SIN EL SISTEMA</th>
                  <th className="p-6 font-bold" data-id="element-137">✅ CON EL SISTEMA</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-138">
                {comparisonData.map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-[#F5F5F5]'} data-id="element-139">
                    <td className="p-6 text-sm font-bold text-[#0D0D0D]" data-id="element-140">
                      {row.s}
                    </td>
                    <td className="p-6 text-sm text-red-700 italic" data-id="element-141">
                      {row.no}
                    </td>
                    <td className="p-6 text-sm font-bold text-green-700" data-id="element-142">
                      {row.yes}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-24 bg-[#F5F5F5]" data-id="element-143">
        <div className="container mx-auto px-4 text-center" data-id="element-144">
          <div className="max-w-3xl mx-auto bg-white p-5 md:p-16 rounded-2xl md:rounded-3xl border-2 border-[#1A237E] shadow-xl" data-id="element-145">
            <img src="https://cdn.magicpatterns.com/uploads/9Bajp4qgWuXDqBzsERmc3o/garantia-7-dias-250.webp" alt="Garantía de satisfacción" className="w-20 md:w-32 h-auto mx-auto mb-3 md:mb-8" width={128} height={128} loading="lazy" decoding="async" data-id="element-146" />
            <h2 className="text-xl md:text-4xl font-bold mb-3 md:mb-6 text-[#0D0D0D]" data-id="element-147">
              GARANTÍA DE SATISFACCIÓN DE 7 DÍAS
            </h2>
            <p className="text-sm md:text-xl text-slate-600 mb-2 md:mb-8 leading-relaxed" data-id="element-148">
              Si el material no mejora la organización de tu negocio, te
              devolvemos el 100%. <br data-id="element-149" />
              <span className="text-base md:text-2xl font-bold text-[#1A237E] block mt-2 md:mt-4 uppercase" data-id="element-150">
                Sin preguntas.
              </span>
            </p>
          </div>
        </div>
      </section>

      <footer className="py-6 md:py-16 bg-[#1A237E] text-white border-t border-white/10" data-id="element-151">
        <div className="container mx-auto px-4 text-center" data-id="element-152">
          <div className="flex justify-center mb-3 md:mb-4" data-id="element-153">
            <Store size={32} className="text-white md:w-10 md:h-10" data-id="element-154" />
          </div>
          <p className="font-bold text-white text-lg md:text-2xl mb-2 md:mb-4" data-id="element-155">
            COMERCIO IMPARABLE™
          </p>
          <p className="text-xs md:text-sm mb-4 md:mb-8 max-w-2xl mx-auto leading-relaxed text-white/80" data-id="element-156">
            El método definitivo para el dueño de almacén, kiosco y autoservicio
            que busca profesionalizar su gestión, blindar su margen contra la
            inflación y proteger su capital.
          </p>
          <p className="text-[10px] md:text-xs text-white/60" data-id="element-157">
            © 2026 — Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </main>;
}
export default LandingPage;